import { lazy } from 'react';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { useSelector } from '@client/hooks/redux.hooks';
import { hasNoWindowChromeSelector } from '@client/selectors/helpers/router';
import { getSessionUserState } from '@client/selectors/helpers/login';
import { Loader } from '@client/components/common/Loader';

const DesktopLoader = lazy(() => import('./Desktop'));
const LoggedOutDesktopNavLoader = lazy(() => import('./Desktop/LoggedOutDesktopNav'));
const MobileLoader = lazy(() => import('./Mobile'));

export const MainNav = () => {
  const isMobile = useIsMobile();

  const userState = useSelector(getSessionUserState);
  const hasNoWindowChrome = useSelector(hasNoWindowChromeSelector);

  if (hasNoWindowChrome) {
    return null;
  }

  if (isMobile) {
    return <Loader load={MobileLoader} />;
  }

  if (userState) {
    return <Loader load={DesktopLoader} />;
  }

  return <Loader load={LoggedOutDesktopNavLoader} />;
};
